module.exports = __webpack_public_path__ + "2bf2609c3e85b187a875a3c25f633e80.png";


//////////////////
// WEBPACK FOOTER
// ./assets/mouth.png
// module id = vtR3
// module chunks = 0